export default __webpack_public_path__ + "static/media/OTorpedo.d0c6f2cc.png";